export { default } from 'antd/lib/message'
